import { gql } from 'apollo-angular';

const GET_ALL_ORGANIZATION_PROVIDERS = gql`
  query GetAllOrganizationProviders {
    organizations(
      filter: {
        and: [
          { organizationType: { equals: "HCO" } }
          { agreementStatus: { oneOf: ["Active", "Pending"] } }
        ]
      }
    ) {
      id
      name
      memberId
      gln
      aptitudeAgreement {
        id
        status
      }
      address {
        address1
        address2
        city
        state
        zip
      }
    }
  }
`;

export default GET_ALL_ORGANIZATION_PROVIDERS;
